<template>
  <button
    v-if="content.renderMode === 'trigger' && !content.hideOnWeb"
    :aria-controls="`panel-${content.id}`"
    :aria-selected="activeTab === content.tabIndex"
    class="ws-nowrap b @hactive:b-white b-transparent rounded-xs px-1 subtitle-4 duration"
    :class="{ 'bg-white c-brand-1': content.id === activeL1?.id }"
    role="tab"
    @click="handleClick"
  >
    {{ content.title }}
  </button>

  <div v-if="content.renderMode === 'content' && !content.hideOnWeb">
    <a class="hidden" :href="content.target?.url">
      {{ content.title }}
    </a>
    <ul :id="content.id" class="px-6">
      <template v-if="content.columns?.length">
        <template v-for="(column, colKey) in content.columns" :key="colKey">
          <cms-section
            v-for="(l2, l2Key) in column.children?.filter((item) => !item.hideOnWeb)"
            :key="l2Key"
            class="h-full children:h-full"
            :section="{ name: l2.id, items: [{ ...l2, menuId: content.id }] }"
          />
        </template>
      </template>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { MegaMenuL1ContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{
  content: MenuItem & { tabIndex: number, renderMode?: 'trigger' | 'content' }
}>()

const { $gtm } = useNuxtApp()
const { activeL1, activeTab } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)

const handleClick = () => {
  if (activeL1) {
    activeL1.value = content
  }
  if (activeTab) {
    activeTab.value = content.tabIndex
  }
  $gtm.push('topNav.onClickMobileMenuSection', formatMegaMenuLevelLabel(getMegaMenuItemLabel(content), 1))
}
</script>
